/* Grabatee USDOT Decal hand-off — v1.0 (2026-08-22)
   Runs on the USDOT Decal product page (sections/sticker-usdot.liquid).
   Reads the design saved by the studio (sessionStorage "grabUsdotHandoff"),
   feeds the 300-DPI PNG into the sticker customizer's #sc-file-input via
   DataTransfer, preselects the matching Size button, and appends USDOT
   line-item properties to the /cart/add.js request. The customizer itself is
   untouched; pricing, approval, Uploadery and cart are the normal path.
   The locked type (rectangle vs contour geometry) is set by an inline script
   in the section BEFORE the customizer initializes — not here. */
(function () {
  "use strict";
  const KEY = "grabUsdotHandoff", MAX_AGE = 6 * 60 * 60 * 1000;
  let data = null;
  try { data = JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (e) { data = null; }
  if (!data || data.type !== "usdot" || !data.dataURL || Date.now() - (data.created || 0) > MAX_AGE) return;

  function dataURLtoFile(url, name) {
    const parts = url.split(","), mime = (parts[0].match(/:(.*?);/) || [])[1] || "image/png";
    const bin = atob(parts[1]); const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
    return new File([arr], name, { type: mime });
  }

  function banner() {
    const root = document.getElementById("stickerCustomizer");
    if (!root || document.getElementById("usdot-handoff-banner")) return;
    const b = document.createElement("div");
    b.id = "usdot-handoff-banner";
    b.setAttribute("role", "status");
    b.style.cssText = "margin:0 0 14px;padding:12px 14px;border:1.5px solid #00AEEF;border-radius:10px;background:#F0FAFF;font-size:13px;line-height:1.45;color:#111";
    const lines = (data.lines || []).map(t => String(t).replace(/</g, "&lt;")).join(" / ");
    b.innerHTML = "<b>Your USDOT decal design is loaded.</b> " + lines + " &bull; " + data.cutStyle + " &bull; letters " + data.letterHeight + " tall. Size is preselected to match; choose how many sets you need, then approve the proof. <a href='javascript:history.back()' style='color:#0077A8'>Edit the design</a>";
    root.insertAdjacentElement("afterbegin", b);
  }

  function preselectSize() {
    const want = String(data.sizeValue || "").toLowerCase().replace(/\s+/g, "");
    const btn = Array.from(document.querySelectorAll("#sc-size-list .sc-size-btn")).find(b => String(b.dataset.size || "").toLowerCase().replace(/\s+/g, "") === want);
    if (btn && !btn.classList.contains("active")) btn.click();
    return !!btn;
  }

  function feedFile() {
    const input = document.getElementById("sc-file-input");
    if (!input) return false;
    try {
      const dt = new DataTransfer();
      dt.items.add(dataURLtoFile(data.dataURL, data.fileName || "usdot-decal.png"));
      input.files = dt.files;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      return true;
    } catch (e) { console.warn("USDOT hand-off: could not feed file", e); return false; }
  }

  /* Wrap fetch so the USDOT properties ride along on the customizer's cart add. */
  const origFetch = window.fetch;
  window.fetch = function (url, opts) {
    try {
      if (typeof url === "string" && url.indexOf("/cart/add") >= 0 && opts && opts.body) {
        const body = JSON.parse(opts.body);
        if (body && Array.isArray(body.items) && body.items[0]) {
          const p = body.items[0].properties = body.items[0].properties || {};
          p["Product"] = "USDOT Number Decal";
          p["USDOT Number"] = data.usdotNumber || "";
          p["Carrier Name"] = data.carrierName || "";
          p["Decal Lines"] = (data.lines || []).join(" | ");
          p["Cut Style"] = data.cutStyle || "";
          p["Letter Height (USDOT line)"] = data.letterHeight || "";
          p["Contrast"] = data.contrast || "";
          p["Lettering"] = (data.font || "") + " \u2022 " + (data.ink || "") + " on " + (data.bg || "");
          p["Sides"] = "Set covers both sides of the power unit";
          p["Design Source"] = "Grabatee USDOT Decal Studio (" + (data.dpi || 300) + " DPI)";
          opts.body = JSON.stringify(body);
        }
      }
    } catch (e) { /* never block the cart */ }
    return origFetch.apply(this, arguments);
  };

  let tries = 0;
  (function poll() {
    tries++;
    const ready = document.getElementById("sc-file-input") && document.querySelector("#sc-size-list .sc-size-btn");
    if (ready) {
      banner();
      preselectSize();
      feedFile();
      return;
    }
    if (tries < 80) setTimeout(poll, 125);
  })();
})();
